export default "/public/etobleh.webp";